/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreditCardPaymentResultGridViewModel } from "../types/CreditCardPaymentResultGridViewModel.ts";

export const creditCardPaymentResultGridViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  parcelId: z.optional(z.number().int()),
  creationDate: z.string().datetime().nullish(),
  creationDateText: z.string().nullish(),
  studentName: z.string().nullish(),
  cpf: z.string().nullish(),
  classStudent: z.string().nullish(),
  merchant: z.string().nullish(),
  serial: z.number().int().nullish(),
  parcelValue: z.optional(z.number()),
  maskedCreditCard: z.string().nullish(),
  transactionCode: z.string().nullish(),
  approved: z.optional(z.boolean()),
  requestStatus: z.string().nullish(),
  paymentMethod: z.optional(z.number().int()),
  parcelStatus: z.optional(z.number().int()),
  hasRecurrenceToken: z.optional(z.boolean()),
  refunded: z.optional(z.boolean()),
  partiallyRefunded: z.optional(z.boolean()),
  refundDateText: z.string().nullish(),
  totalRefund: z.number().nullish(),
  chargedBack: z.optional(z.boolean()),
  chargebackDateText: z.string().nullish(),
  chargebackValue: z.number().nullish(),
}) as unknown as ToZod<CreditCardPaymentResultGridViewModel>;
